import { PREDEFINED_PROMPTS } from "./constants/aiPrompts";
import PromptBox from "./PromptBox/PromptBox";
import PromptHistory from "./PromptHistory";

const AIPanel = ({
    open,
    history,
    loading,
    onSubmit,
    onHistorySelect,
    selectedHistoryId
}) => {

    return (

        <div
            className={`
            fixed
            right-0
            top-0
            h-screen
            bg-white
            shadow-2xl
            transition-all
            duration-300
            border-l
            z-40
            ${open ? "w-[360px]" : "w-0 overflow-hidden"}
        `}
        >

            <div className="flex flex-col h-full">

                <div className="pt-5 px-3 pb-2 border-b flex gap-2 items-center bg-gradient-to-r from-cyan-50 via-white to-indigo-50 opacity-70">

                <div className="h-2 w-2 rounded-full bg-emerald-400 animate-pulse"/>
                <h2 className="font-bold text-lg">
                AI Assistant
                </h2>
                    {/* <h2 className="font-bold text-lg">
                        🤖 AI Dashboard
                    </h2> */}
                </div>

                <div className="flex-1 overflow-y-auto">
                    <PromptHistory 
                      history={history} 
                      suggestions={PREDEFINED_PROMPTS}
                      onSelect={onSubmit}
                      onHistorySelect={onHistorySelect}
                      selectedHistoryId={selectedHistoryId}
                    />
                </div>

                <div className="border-t">
                    <PromptBox
                        loading={loading}
                        onSubmit={onSubmit}
                    />
                </div>
            </div>
        </div>
    );
};

export default AIPanel;